import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";
import {
  ExperienceStepModel,
  GeneralExperienceWizardInfo,
  GeneralExpWizardInfoByLang,
} from "@models/experience-steps.model";

export const LANGUAGE: { [key: string]: string } = {
  BG: "bg",
  EN: "en",
};

var STEPS = [
  { stepIndex: 1, stepTitle: "General information", isComplete: false },
  { stepIndex: 2, stepTitle: "Location & address", isComplete: false },
  { stepIndex: 3, stepTitle: "Images", isComplete: false },
  { stepIndex: 4, stepTitle: "Finishing touches", isComplete: false },
];

@Injectable({
  providedIn: "root",
})
export class ExperienceStepsService {
  steps: BehaviorSubject<ExperienceStepModel[]> = new BehaviorSubject<
    ExperienceStepModel[]
  >(Array.from(STEPS));
  currentStep: BehaviorSubject<ExperienceStepModel> = new BehaviorSubject<ExperienceStepModel>(
    null
  );

  stepsOpenedEarlier: Array<number> = [1];

  generalInfoByLang: GeneralExpWizardInfoByLang = {
    language: LANGUAGE.EN,
    selectedCoverImage: null,
    activeCoverImage: null,
    loadedImagesArray: [],
    dataByLang: {},
  };

  constructor() {
    Object.keys(LANGUAGE).forEach((key) => {
      this.generalInfoByLang.dataByLang[LANGUAGE[key]] = {
        title: null,
        description: null,
        typeIndex: null,
        scheduleExperience: [],
        latitude: 42.168475,
        longitude: 24.763898,
        locationAddress: "",
        locationDescription: "",
        locationName: "",
        city: "",
        country: "",
      };
    });

    this.currentStep.next(this.steps.value[0]);
  }

  setCurrentStep(step: ExperienceStepModel): void {
    this.currentStep.next(step);
  }

  getCurrentStep(): Observable<ExperienceStepModel> {
    return this.currentStep.asObservable();
  }

  getSteps(): Observable<ExperienceStepModel[]> {
    return this.steps.asObservable();
  }

  getGeneralInfo(): GeneralExpWizardInfoByLang {
    return this.generalInfoByLang;
  }

  isStepOpenedEarlier(stepIndex: number) {
    return this.stepsOpenedEarlier.includes(stepIndex);
  }

  moveToNextStep(): void {
    const index = this.currentStep.value.stepIndex;

    if (index < this.steps.value.length) {
      this.stepsOpenedEarlier.push(this.steps.value[index].stepIndex);
      this.currentStep.next(this.steps.value[index]);
    }
  }

  moveToPrevStep(): void {
    const index = this.currentStep.value.stepIndex;
    if (index > 1) {
      this.currentStep.next(this.steps.value[index - 2]);
    }
  }

  isLastStep(): boolean {
    return this.currentStep.value.stepIndex === this.steps.value.length;
  }
  isFirstStep(): boolean {
    return this.currentStep.value.stepIndex === 1;
  }

  clearService() {
    STEPS = [
      { stepIndex: 1, stepTitle: "General information", isComplete: false },
      { stepIndex: 2, stepTitle: "Location & address", isComplete: false },
      { stepIndex: 3, stepTitle: "Images", isComplete: false },
      { stepIndex: 4, stepTitle: "Finishing touches", isComplete: false },
    ];

    this.steps = new BehaviorSubject<ExperienceStepModel[]>(Array.from(STEPS));
    this.currentStep = new BehaviorSubject<ExperienceStepModel>(null);
    this.stepsOpenedEarlier = [1];
    this.generalInfoByLang = {
      language: LANGUAGE.EN,
      selectedCoverImage: null,
      activeCoverImage: null,
      loadedImagesArray: [],
      dataByLang: {},
    };

    Object.keys(LANGUAGE).forEach((key) => {
      this.generalInfoByLang.dataByLang[LANGUAGE[key]] = {
        title: null,
        description: null,
        typeIndex: null,
        scheduleExperience: [],
        latitude: 42.168475,
        longitude: 24.763898,
        locationAddress: "",
        locationDescription: "",
        locationName: "",
        city: null,
        country: null,
      };
    });

    this.currentStep.next(this.steps.value[0]);
  }
}
